// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomNode_root__1Gyvu","expandIconWrapper":"CustomNode_expandIconWrapper__2zXDC","isOpen":"CustomNode_isOpen__bV1pq","labelGridItem":"CustomNode_labelGridItem__1VTC3"};